import * as types from '_/vuex/mutation-types';

import _ from 'lodash';

import Vue from 'vue';

import { pError } from '_/helpers/logger';

/**
 * Define the module state
 *
 * @type {object}
 */
const state = {
    testing: {},
};

/**
 * Define the module mutations
 *
 * @type {object}
 */
const mutations = {
    /**
     * Populates the testing array
     *
     * @param   {object}  options.state
     * @param   {array}  options.values
     * @return  {void}
     */
    [types.DEFAULT_TEST_MUTATION](state, { id, name, newValue }) {
        state.testing = { id, name, newValue };
    },
};

/**
 * Define the module getters
 *
 * @type {object}
 */
const getters = {
    testing: state => state
};

/**
 * Import the module actions as an object containing action methods
 *
 * @type {object}
 */
import actions from '_/vuex/actions/testingActions';

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
